// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay_VsYvq {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.3);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
}

.popupContainer_qqyb5 {
	background: white;
	border-radius: 8px;
	width: 520px;
	box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
	padding: 20px;
}

.header_TPFel {
	font-size: 18px;
	font-weight: 500;
	margin-bottom: 10px;
	color: var(--_3c3a3a-color);
}

.textArea_WugW1 {
	width: 100%;
	height: 80px;
	border-radius: 4px;
	background: var(--f5-background);
	padding: 10px;
	font-size: 14px;
	resize: none;
	outline: none;
}

.charCounter_jSegy {
	text-align: right;
	font-size: 12px;
	color: #999;
	margin-top: 5px;
}

.actions_bwREp {
	display: flex;
	justify-content: space-between;
	margin-top: 20px;
}

.cancelButton_zn8hv {
	background: none;
	border: none;
	color: #666;
	font-size: 14px;
	cursor: pointer;
	font-weight: 600;
}

.saveButton_BbBnW {
	background-color: var(--_16c0982e-background);
	color: var(--white-color);
	padding: 8px 16px;
	border-radius: 4px;
	border: none;
	font-size: 14px;
	cursor: pointer;
	font-weight: 600;
}

.saveButton_BbBnW:disabled {
	background-color: #aaa;
	cursor: not-allowed;
}

.checkboxIcon_XJQon {
	color: var(--_16c09821-background);
}

.checkedButton_IIF57 {
	padding: 3px;
	border-radius: 50%;
	transition:
		background-color 0.2s ease-in-out,
		transform 0.2s ease-in-out;
	animation: checkboxCheckedAnimation_sfEPn 0.25s ease;
	&:hover {
		background-color: var(--f5-background);
	}
}

.uncheckedButton_vhxTC {
	padding: 3px;
	border-radius: 50%;
	transition:
		background-color 0.2s ease-in-out,
		transform 0.2s ease-in-out;
	animation: checkboxUncheckedAnimation_L08NP 0.25s ease;
	&:hover {
		background-color: var(--f5-background);
	}
}

@keyframes checkboxCheckedAnimation_sfEPn {
	0% {
		transform: scale(0.85);
	}
	50% {
		transform: scale(1.1);
	}
	100% {
		transform: scale(1);
	}
}

@keyframes checkboxUncheckedAnimation_L08NP {
	0% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.1);
	}
	100% {
		transform: scale(0.85);
	}
}
.checkboxContainer_ubuQ2 {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 10px;
	flex-direction: row;
	margin-top: -5px;
}
.content_RRfSX {
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	flex-direction: column;
	gap: 10px;
	width: 100%;
}
.dateContainer_Z9INM {
	position: relative;
	padding: 5px 10px;
	border-radius: 4px;
	background-color: var(--_16c098-color);
	color: var(--white-color);
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/SetStartEndDatePopup.module.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,8BAA8B;CAC9B,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,aAAa;AACd;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,YAAY;CACZ,2CAA2C;CAC3C,aAAa;AACd;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,gCAAgC;CAChC,aAAa;CACb,eAAe;CACf,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,WAAW;CACX,eAAe;CACf,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,6CAA6C;CAC7C,yBAAyB;CACzB,iBAAiB;CACjB,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB;;4BAE2B;CAC3B,oDAA8C;CAC9C;EACC,sCAAsC;CACvC;AACD;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB;;4BAE2B;CAC3B,sDAAgD;CAChD;EACC,sCAAsC;CACvC;AACD;;AAEA;CACC;EACC,sBAAsB;CACvB;CACA;EACC,qBAAqB;CACtB;CACA;EACC,mBAAmB;CACpB;AACD;;AAEA;CACC;EACC,mBAAmB;CACpB;CACA;EACC,qBAAqB;CACtB;CACA;EACC,sBAAsB;CACvB;AACD;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,SAAS;CACT,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,sBAAsB;CACtB,SAAS;CACT,WAAW;AACZ;AACA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,sCAAsC;CACtC,yBAAyB;CACzB,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;AAClB","sourcesContent":[".overlay {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground: rgba(0, 0, 0, 0.3);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tz-index: 1000;\n}\n\n.popupContainer {\n\tbackground: white;\n\tborder-radius: 8px;\n\twidth: 520px;\n\tbox-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);\n\tpadding: 20px;\n}\n\n.header {\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tmargin-bottom: 10px;\n\tcolor: var(--_3c3a3a-color);\n}\n\n.textArea {\n\twidth: 100%;\n\theight: 80px;\n\tborder-radius: 4px;\n\tbackground: var(--f5-background);\n\tpadding: 10px;\n\tfont-size: 14px;\n\tresize: none;\n\toutline: none;\n}\n\n.charCounter {\n\ttext-align: right;\n\tfont-size: 12px;\n\tcolor: #999;\n\tmargin-top: 5px;\n}\n\n.actions {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-top: 20px;\n}\n\n.cancelButton {\n\tbackground: none;\n\tborder: none;\n\tcolor: #666;\n\tfont-size: 14px;\n\tcursor: pointer;\n\tfont-weight: 600;\n}\n\n.saveButton {\n\tbackground-color: var(--_16c0982e-background);\n\tcolor: var(--white-color);\n\tpadding: 8px 16px;\n\tborder-radius: 4px;\n\tborder: none;\n\tfont-size: 14px;\n\tcursor: pointer;\n\tfont-weight: 600;\n}\n\n.saveButton:disabled {\n\tbackground-color: #aaa;\n\tcursor: not-allowed;\n}\n\n.checkboxIcon {\n\tcolor: var(--_16c09821-background);\n}\n\n.checkedButton {\n\tpadding: 3px;\n\tborder-radius: 50%;\n\ttransition:\n\t\tbackground-color 0.2s ease-in-out,\n\t\ttransform 0.2s ease-in-out;\n\tanimation: checkboxCheckedAnimation 0.25s ease;\n\t&:hover {\n\t\tbackground-color: var(--f5-background);\n\t}\n}\n\n.uncheckedButton {\n\tpadding: 3px;\n\tborder-radius: 50%;\n\ttransition:\n\t\tbackground-color 0.2s ease-in-out,\n\t\ttransform 0.2s ease-in-out;\n\tanimation: checkboxUncheckedAnimation 0.25s ease;\n\t&:hover {\n\t\tbackground-color: var(--f5-background);\n\t}\n}\n\n@keyframes checkboxCheckedAnimation {\n\t0% {\n\t\ttransform: scale(0.85);\n\t}\n\t50% {\n\t\ttransform: scale(1.1);\n\t}\n\t100% {\n\t\ttransform: scale(1);\n\t}\n}\n\n@keyframes checkboxUncheckedAnimation {\n\t0% {\n\t\ttransform: scale(1);\n\t}\n\t50% {\n\t\ttransform: scale(1.1);\n\t}\n\t100% {\n\t\ttransform: scale(0.85);\n\t}\n}\n.checkboxContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tgap: 10px;\n\tflex-direction: row;\n\tmargin-top: -5px;\n}\n.content {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tflex-direction: column;\n\tgap: 10px;\n\twidth: 100%;\n}\n.dateContainer {\n\tposition: relative;\n\tpadding: 5px 10px;\n\tborder-radius: 4px;\n\tbackground-color: var(--_16c098-color);\n\tcolor: var(--white-color);\n\tcursor: pointer;\n\tuser-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `overlay_VsYvq`,
	"popupContainer": `popupContainer_qqyb5`,
	"header": `header_TPFel`,
	"textArea": `textArea_WugW1`,
	"charCounter": `charCounter_jSegy`,
	"actions": `actions_bwREp`,
	"cancelButton": `cancelButton_zn8hv`,
	"saveButton": `saveButton_BbBnW`,
	"checkboxIcon": `checkboxIcon_XJQon`,
	"checkedButton": `checkedButton_IIF57`,
	"checkboxCheckedAnimation": `checkboxCheckedAnimation_sfEPn`,
	"uncheckedButton": `uncheckedButton_vhxTC`,
	"checkboxUncheckedAnimation": `checkboxUncheckedAnimation_L08NP`,
	"checkboxContainer": `checkboxContainer_ubuQ2`,
	"content": `content_RRfSX`,
	"dateContainer": `dateContainer_Z9INM`
};
export default ___CSS_LOADER_EXPORT___;
